import { render, staticRenderFns } from "./PupilEdit.vue?vue&type=template&id=fb1a53ec&scoped=true&"
import script from "./PupilEdit.vue?vue&type=script&lang=js&"
export * from "./PupilEdit.vue?vue&type=script&lang=js&"
import style0 from "./PupilEdit.vue?vue&type=style&index=0&id=fb1a53ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1a53ec",
  null
  
)

export default component.exports